<template>
  <div class="journal">
    <!-- 操作日志 -->
    <div class="title">
      <label>AI修圖購買及記錄</label>
    </div>
    <div class="journal-title">
      <el-form
        :border="true"
        :inline="true"
        class="demo-form-inline"
      >
        <div class="fontai">
          <svg
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#iconxiutucishu" />
          </svg>
          AI修圖次数：
          <span>
            {{ aiRetouchCount }}
          </span> 
        </div>
        <el-form-item prop="sourceType">
          <el-select
            v-model="sourceType"
            placeholder="記錄類型"
            class="select"
          >
            <el-option
              v-for="item in operationTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="留言時間："
          prop="startTime"
          class="doTime"
        >
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="選擇日期"
            class="block"
            :picker-options="start_Date"
          />
        </el-form-item>
        <el-form-item prop="endTime">
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="選擇日期"
            class="block"
            :picker-options="end_Date"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            class="search-btn"
            @click="search_action"
          >
            搜尋
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            class="reset-btn"
            @click="reset_action"
          >
            重置
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="isAIRetouchImage"
            type="primary"
            @click="aiCountVisible = true"
          >
            購買AI修圖次數
          </el-button>
        </el-form-item>
        <span class="tips">試用期間暫不開放購買功能，敬請留意。</span>
      </el-form>
    </div>
    <div class="journal-content">
      <el-table
        v-loading="firstLoading"
        :data="tableData"
        tooltip-effect="dark myTooltip"
        :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#44444F' }"
        empty-text="暫無數據"
        style="width: 100%"
      >
        <el-table-column
          prop="sourceTypeStr"
          label="記錄類型"
          width="auto"
          min-width="20%"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="content"
          label="次數"
          width="auto"
          min-width="25%"
        >
          <template slot-scope="scope">
            <span :class="[scope.row.retouchNumber > 0 ? 'green' : 'red']">
              {{ scope.row.retouchNumber > 0 ? '+' + scope.row.retouchNumber : scope.row.retouchNumber }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="鑽石"
          width="auto"
          min-width="25%"
        >
          <template slot-scope="scope">
            <span :class="[scope.row.sourceType == 1 ? 'red' : scope.row.diamond == 0 ? '' : 'green']">
              {{ scope.row.diamond == 0 ? '-' : scope.row.sourceType == 1 ? '-' + scope.row.diamond : '+' + scope.row.diamond }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="交易時間"
          :show-overflow-tooltip="true"
          min-width="30%"
        >
          <template slot-scope="res">
            {{ res.row.createTime.split('T')[0] }}
            {{ res.row.createTime.split('T')[1].slice(0, 5) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          class="page"
          background
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="count"
          @size-change="handleSizeChange"
          @current-change="currentChange"
        />
      </div>
    </div>
    <!-- 購買砖石彈框 -->
    <el-dialog
      title="購買AI修圖次數"
      :visible.sync="aiCountVisible"
      width="440px"
      class="buy-dialog"
    >
      <div class="buy-content">
        <div class="icon-box">
          <i class="el-icon-warning" />
        </div>
        <div class="buy-info">
          <div class="main-tip">
            購買AI修圖次數 <span class="highlight">{{ aiDiamond }}</span> 鑽石 <span class="highlight">{{ aiCount }}</span> 次
          </div>
          <div class="sub-tip">
            需消費鑽石數量 <span class="diamond-count">{{ aiDiamond }}</span>
          </div>
          <div
            v-if="aiDiamond > remainderDiamond"
            class="red"
          >
            鑽石餘額不足
          </div>
        </div>
      </div>

      <span   
        slot="footer" 
        class="dialog-footer"
      >
        <el-button @click="aiCountVisible = false">取 消</el-button>
        <el-button 
          type="primary" 
          @click="buyaicount"
        >確 認</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
  export default {
      name: 'Journal',
      data() {
          const end = new Date();
          const start = new Date();
          start.setFullYear(start.getFullYear() - 1); 
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 999);
          return {
              firstLoading:true,
              aiCountVisible:false,
              copyText: '複製文字',
              // 总页数
              count: 0,
              aiRetouchCount:'',
              // 搜索参数
              sourceType: '', //操作类型
              startTime: start,
              endTime: end,

              // 用于计算限制条件的基准值 (保持为毫秒戳用于 disabledDate 比较)
              nowUp: start.getTime(),
              nowDown: end.getTime(),

              pageIndex: 1, //页数
              pageCount: 10, //每页显示条数
              // 操作类型
              operationTypes: [
                  {
                      value: 0,
                      label: '全部'
                  },
                  {
                      value: 1,
                      label: '购买'
                  },
                  {
                      value: 2,
                      label: '使用'
                  },
              ],
              // 表单数据
              tableData: [],
              // 查询条件
              searchData: '',
              // start_Date 限制
              start_Date: {
                disabledDate: time => {
                  // 逻辑：不能选择未来
                  if (time.getTime() > Date.now()) {return true};
                  // 逻辑：不能晚于已选的结束时间
                  if (this.endTime) {
                    return time.getTime() > new Date(this.endTime).getTime();
                  }
                  return false;
                }
              },
              // end_Date 限制
              end_Date: {
                disabledDate: time => {
                  // 逻辑：不能选择未来
                  if (time.getTime() > Date.now()) {return true};
                  // 逻辑：不能早于已选的开始时间
                  if (this.startTime) {
                    return time.getTime() < new Date(this.startTime).getTime();
                  }
                  return false;
                }
              },
              isAIRetouchImage:false,
              isHaveAIRetouchLog:false,
              aiRetouchImage:false,
              aiCount:0,
              aiDiamond:0,
              remainderDiamond:'',
              userInfo: [],
              // startTime: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000, //起始时间
              // endTime: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000 + (24 * 60 * 60 * 1000 - 1000), //终止时间
              // nowDown: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000 + (24 * 60 * 60 * 1000 - 1000),
              // nowUp: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000,
              // 时间限制
              // end_Date: {
              //     disabledDate: time => {
              //         if (this.startTime) {
              //             return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30) || time < this.startTime;
              //         } 
              //             return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30);
                      
              //     }
              // },
              // start_Date: {
              //     disabledDate: time => {
              //         if (this.endTime) {
              //             return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30) || time > this.endTime;
              //         } 
              //             return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30);
                      
              //     }
              // }
          };
      },
      async created() {
          await this.getUserInfo()
          this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'journalPageCount') || 10;
          this.getTableData();
          this.getCompanyCofig();
      },
      methods: {
        async getPropertyCoin() {
            let res = await this.axios.get(this.pub.getApi().GetDepartmentById, {
                params: {
                    departmentID: this.userInfo.departmentID
                }
            });
            let { code, message, result } = res.data;
            if (code === 0) {
                this.remainderDiamond = Number(result.remainderDiamond);
            } else {
            }
        },
        getUserInfo() {
          return new Promise((resolve, reject) => { 
            this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
              if (res.data.code === 0 && res.data.result) {
                this.userInfo = res.data.result;
              } else {
              }
            });
            resolve()
          });
        },
          getCompanyCofig(){
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                if (res.data.code === 0 && res.data.result) {
                  // 是否使用ai修图
                  this.isAIRetouchImage = res.data.result.isAIRetouchImage;
                  // 是否存在ai修图日志
                  this.isHaveAIRetouchLog = res.data.result.isHaveAIRetouchLog;
                  // 购买配置 多少次：多少钻石
                  let [aiCount, aiDiamond] = res.data.result.aiRetouchImage.split(':').map(Number);
                  this.aiCount = aiCount;
                  this.aiDiamond =  Number(aiDiamond);
                  if (res.data.result.accountType && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2)) {
                    this.getPropertyCoin(this.userInfo.departmentID);
                  }else{
                    this.remainderDiamond = Number(this.userInfo.remainderDiamond);
                  }
                }
            });
          },
          async buyaicount(){
            let { data } = await this.axios.post(this.pub.getApi().BuyAIRetouchCount);
              if (data.code === 0) {
                  this.aiCountVisible = false
                  this.getTableData()
                  this.$message.success('AI修圖購買成功');
              }else{
                  this.$message.error(data.message || 'AI修圖購買失敗');
              }
          },
          // 获取搜索参数
          getSearchData() {
              const formatLocal = (date) => {
                  if (!date) {return '';}
                  // 如果傳進來的是字符串（比如重置後），先轉回 Date 對象
                  const d = new Date(date);
                  
                  const year = d.getFullYear();
                  const month = String(d.getMonth() + 1).padStart(2, '0');
                  const day = String(d.getDate()).padStart(2, '0');
                  const hours = String(d.getHours()).padStart(2, '0');
                  const minutes = String(d.getMinutes()).padStart(2, '0');
                  const seconds = String(d.getSeconds()).padStart(2, '0');

                  // 返回純字符串格式，不帶 T 和 Z
                  // 例如：2025-04-07 00:00:00
                  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
              };

              return {
                  sourceType: (this.sourceType === undefined || this.sourceType === null || this.sourceType === 0) ? '' : this.sourceType,
                  pageIndex: this.pageIndex,
                  pageCount: this.pageCount,
                  startTime: formatLocal(this.startTime), 
                  endTime: formatLocal(this.endTime)
              };
          },
          // 重置功能也要相应修改
          reset_action() {
              this.sourceType = '';
              // const start = new Date();
              // start.setHours(0, 0, 0, 0);
              // const end = new Date();
              // end.setHours(23, 59, 59, 999);
              const end = new Date();
              const start = new Date();
              start.setFullYear(start.getFullYear() - 1); 
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              this.startTime = start;
              this.endTime = end;
              
              this.pageIndex = 1;
              this.getTableData();
          },          // 查询功能
          search_action() {
              // if (this.startTime === null || this.endTime === null) {
              //     this.$message({
              //         showClose: true,
              //         message: '請選擇搜尋時間',
              //         type: 'error'
              //     });
              // } else {
                  this.pageIndex = 1;
                  let searchData = this.getSearchData();
                  this.getTableData(searchData);
                  this.$message({
                      showClose: true,
                      message: '搜尋成功',
                      type: 'success'
                  });
              // }
          },
          // 重置功能
          // reset_action() {
          //     (this.sourceType = ''),  (this.startTime = new Date(new Date().toLocaleDateString()).getTime()), (this.endTime = new Date(new Date().toLocaleDateString()).getTime() + (24 * 60 * 60 * 1000 - 1000));
          //     this.getTableData();
          // },
          // 分页功能
          currentChange(pageIndex) {
              this.pageIndex = pageIndex;
              // this.searchData = this.getSearchData()
              this.getTableData();
          },
          // 获取当前每页显示数量
          handleSizeChange(pageCount) {
              this.pub.userPageSize(this.$store.state.userInfo.accountID,'airecordPageCount',pageCount)
              this.pageCount = pageCount;
              this.getTableData();
          },
  
          // 列表数据渲染
          async getTableData() {
              let { data } = await this.axios.post(this.pub.getApi().GetAIRetouchLog, this.getSearchData());
              if (data.code === 0) {
                  this.aiRetouchCount = data.result.aiRetouchCount;
                  this.count = data.result.count;
                  this.tableData = data.result.data;
                  this.firstLoading = false;
              }else{
                  this.firstLoading = false;
              }
          }
      }
  };
  </script>
  <style lang="less" scoped>
  @import '../../assets/css/element-reset.less';
  .buy-content {
    display: flex;
    align-items: flex-start; 
    padding: 10px 20px;
  }
  .red {
        color: #e50113;
  }
  .green {
      color: green;
  }
  .icon-box {
    margin-right: 15px;
  }
  .icon-box .el-icon-warning {
    color: #0064FF; 
    font-size: 28px; 
  }

  .buy-info {
    display: flex;
    flex-direction: column;
    gap: 8px; 
  }

  .main-tip {
    font-size: 16px;
    color: #303133;
    font-weight: 500;
  }

  .sub-tip {
    font-size: 14px;
    color: #909399;
  }

  .highlight, .diamond-count {
    color: #F56C6C; 
    font-weight: bold;
    margin: 0 2px;
  }
    
  .journal {
      text-align: left;
      padding: 20px;
      .el-input--suffix .el-input__inner {
          padding-right: 15px;
      }
      .title {
          margin: 0 40px 10px 0;
          font-size: 24px;
          padding-bottom: 20px;
      }
      .search-btn {
          background-color: #e50113;
          border: none;
          width: 88px;
          margin-left: 10px;
      }
      .reset-btn {
          background-color: #bbbbbb;
          border: none;
          color: #ffffff;
          width: 88px;
      }
      .el-form-item {
          margin-right: 15px;
      }
      .el-form-item__label {
          padding-right: 5px;
          color: #666 !important;
      }
      .journal-title {
          padding-bottom: 20px;
          .fontai{
            display: inline-block;
            padding-top: 10px;
            padding-right: 10px;
            color: #000000;
            font-size: 16px;
            span{
              color:#0062FF ;
            }
          }
          /deep/.el-input__inner{
            border-radius: 10px;

          }
          .el-button {
              border-radius: 10px;
          }
          .el-select {
              height: 38px;
          }
          .select {
              width: 120px;
          }
          .search {
              width: 175px;
          }
          .block {
              width: 140px;
              height: 25px;
          }
          .tips{
            font-size: 16px;
            color: #2c3e50;
            font-weight: 700;
            line-height: 37px;
          }
      }
      .journal-content {
          width: 100%;
          height: 100%;
          background-color: #fff;
          border-radius: 20px;
          padding: 20px;
          box-sizing: border-box;
          color: #44444f;
          font-size: 14px;
          .row-span{
              width:85%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
          }
          .el-table::before {
              height: 0;
          }
          .footer {
              span {
                  font-size: 14px;
                  color: #44444f;
  
                  margin-left: 16px;
              }
              margin-top: 16px;
              padding-top: 20px;
              box-sizing: border-box;
              height: 72px;
              .page {
                  float: right;
              }
              .input-number {
                  text-align: left;
                  float: right;
                  width: 70px;
              }
          }
          .flex-cont{
              display: flex;
              flex-direction: row;
              justify-content: space-around;
          }
      }
  }
  </style>
  